import React from 'react';

export interface LogViewTableRowProps {
  onClick: () => void;
}

export abstract class LogViewTableRow<
  Props extends LogViewTableRowProps,
  State = Record<string, any>,
> extends React.Component<Props, State> {}
